import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Container,
  Grid,
  Paper,
  Typography,
} from '@mui/material';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import ListAltIcon from '@mui/icons-material/ListAlt';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../Services/axiosInstance.js';
import { getVendorContact, getVendorDisplayName } from '../utils/auth.js';
import { timeGreetings } from '../utils/helper.js';

export default function VendorWelcome() {
  const navigate = useNavigate();
  const displayName = getVendorDisplayName();
  const [walletAmount, setWalletAmount] = useState(0);

  useEffect(() => {
    axiosInstance.get('/api/v1/vendor/orders', { params: { page: 1, page_size: 1 } })
      .then((res) => {
        const data = res.data?.data;
        setWalletAmount(data?.vendor_wallet_balance ?? data?.total_commission ?? 0);
      })
      .catch((error) => {
        if(error.response.status === 401 || error.response.status === 404) {
          localStorage.clear();
          navigate('/vendor/login');
        }
      });
  }, []);

  return (
    <Container
      maxWidth="md"
      sx={{
        px: { xs: 2, sm: 3 },
        py: { xs: 3, md: 4 },
        mt: { xs: 1, md: 2 },
      }}
    >
      <Paper
        elevation={0}
        sx={{
          border: '1px solid #EAECF0',
          borderRadius: '16px',
          p: { xs: 3, sm: 4 },
          background: 'linear-gradient(180deg, #FFFFFF 0%, #F9FAFB 100%)',
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            color: '#101828',
            fontSize: { xs: '1.5rem', sm: '1.75rem' },
            textAlign: { xs: 'center', sm: 'left' },
          }}
        >
          Hello {displayName}, {timeGreetings()}
        </Typography>
        <Typography
          sx={{
            mt: 1,
            color: '#667085',
            fontSize: '0.95rem',
            textAlign: { xs: 'center', sm: 'left' },
          }}
        >
          Welcome to your seller portal. Create orders or review your order history.
        </Typography>

        <Grid container spacing={2} sx={{ mt: 3, alignItems: 'stretch' }}>
          <Grid item xs={12} sm={6} sx={{ display: 'flex' }}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                flex: 1,
              }}
            >
              <Paper
                elevation={0}
                sx={{
                  p: 2.5,
                  borderRadius: '12px',
                  border: '1px solid #EAECF0',
                  flex: 1,
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                  <LocalPhoneIcon sx={{ color: '#667085', fontSize: 20 }} />
                  <Typography sx={{ color: '#667085', fontSize: '0.875rem' }}>Seller contact</Typography>
                </Box>
                <Typography sx={{ fontWeight: 600, color: '#101828', fontSize: '1.05rem' }}>
                  {getVendorContact() || '—'}
                </Typography>
              </Paper>
              <Button
                className="btn primary-button"
                startIcon={<AddShoppingCartIcon />}
                onClick={() => navigate('/vendor/create-order')}
                fullWidth
                sx={{
                  mt: 2,
                  py: 1.35,
                  minHeight: 48,
                  textTransform: 'none',
                  fontWeight: 600,
                  borderRadius: '10px',
                }}
              >
                Create New Order
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} sx={{ display: 'flex' }}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                flex: 1,
              }}
            >
              <Paper
                elevation={0}
                sx={{
                  p: 2.5,
                  borderRadius: '12px',
                  border: '1px solid #EAECF0',
                  flex: 1,
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                  <AccountBalanceWalletIcon sx={{ color: '#667085', fontSize: 20 }} />
                  <Typography sx={{ color: '#667085', fontSize: '0.875rem' }}>Wallet balance</Typography>
                </Box>
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: '1.25rem',
                    color: Number(walletAmount) < 0 ? '#B42318' : '#027A48',
                  }}
                >
                  ₹{Number(walletAmount).toLocaleString('en-IN')}
                </Typography>
              </Paper>
              <Button
                variant="outlined"
                startIcon={<ListAltIcon />}
                onClick={() => navigate('/vendor/orders')}
                fullWidth
                sx={{
                  mt: 2,
                  py: 1.35,
                  minHeight: 48,
                  textTransform: 'none',
                  fontWeight: 600,
                  borderRadius: '10px',
                  borderColor: '#D0D5DD',
                  color: '#344054',
                }}
              >
                My Orders
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
}
